export default "<section>\n    <app-work></app-work>\n</section>\n"